module.exports = __webpack_public_path__ + "static/media/card_barnacles.f563e92e.jpg";